export const getSupportUrl = (url, isLoggedIn) => {
  if (!isLoggedIn) {
    return url;
  }
  return `/zendesk/login.html?return_to=${url}`;
};

const urls = {
  external: {
    announcements: '/%locale/support/categories/115000056351',
    careers: '/%locale/career',
    support: 'https://binance.zendesk.com/hc/%locale',
    supportLogin: '/zendesk/login.html?return_to=https://binance.zendesk.com/hc/%locale',
    supportRequest: 'https://binance.zendesk.com/hc/%locale/requests/new',
    aboutFee: 'https://binance.zendesk.com/hc/%locale/articles/115000583311',
    notGetAccount: 'https://binance.zendesk.com/hc/%locale/articles/115003736451',
    contactUs: 'https://binance.zendesk.com/hc/en-us',
    securityTips: '/sections/360000011632',
    setEmailWhiteList: 'https://binance.zendesk.com/hc/%locale/articles/360000444531',
    faq: 'https://binance.zendesk.com/hc/%locale',
    contactUs2: '/%locale/about',
  },
  wallet: {
    balances: '/%locale/usercenter/wallet/balances',
    deposit: '/%locale/usercenter/wallet/deposit/BTC',
    withdraw: '/%locale/usercenter/wallet/withdrawals/BTC',
    depositWithdrawHistory: '/%locale/usercenter/wallet/money-log/deposit',
    distributionHistory: '/%locale/usercenter/wallet/distribution-history',
  },
  user: {
    index: '/%locale/usercenter/dashboard/overview',
    addressManagement: '/userCenter/addressManagement.html',
    addressVerify: '/%locale/usercenter/address/verify',
    xfers: '/%locale/usercenter/xfers',
    security: '/%locale/usercenter/security',
    identity: '/userCenter/identity.html',
    orderHistory: '/%locale/usercenter/history/trade-order',
    marginOrderHistory: '/%locale/usercenter/margin-orders/user-trade',
    balances: '/userCenter/balances.html',
    deposits: '/userCenter/deposit.html',
    withdrawals: '/userCenter/withdrawal.html',
    moneyLog: '/%locale/usercenter/wallet/money-log/deposit',
    openOrders: '/%locale/usercenter/open-order',
    tradeHistory: '/%locale/usercenter/user-trade',
    creditcard: '/%locale/buy-sell-crypto',
    bindPhone: '/userCenter/bindPhone.html',
    unbindPhone: '/userCenter/unbindPhone.html',
    password: '/userCenter/modifyPwd.html',
    setAntiPhishing: '/userCenter/setAntiPhishingCode.html',
    modifyAntiPhishing: '/userCenter/modifyAntiPhishingCode.html',
    googleAuth: '/userCenter/googleAuthentication.html',
    unbindGoogleAuth: '/userCenter/unbindgoogle.html',
    deviceDetail:
      '/userCenter/userDeviceDetail.html?devicePk=%devicePrimaryKey&deviceName=%deviceName',
    yoPayment: '/%locale/usercenter/payment/yopayment',
  },
  site: {
    about: '/%locale/about',
    terms: '/%locale/terms',
    privacy: '/%locale/privacy',
    fees: '/%locale/fee/schedule',
    contact: '/contactUsCn.html',
    api: 'https://github.com/binance-exchange/binance-official-api-docs',
    applyToList: '/%locale/usercenter/coin-apply',
    download: '/clientDownloads.html',
    bnb: '/%locale/use-bnb',
    blog: '/%locale/blog',
    mHomePage: '/m-HomePage.html',
    login: '/%locale/login',
    register: '/%locale/register',
    resetPassword: '/%locale/forgotPassword',
    resetGoogleAuth: '/%locale/reset2fa/google',
    resetMobile: '/%locale/reset2fa/mobile',
    community: '/%locale/community',
    referral: '/%locale/activity/referral',
  },
  media: {
    community: '/%locale/community',
    facebook: 'https://www.facebook.com/binance',
    twitter: 'https://twitter.com/binance',
    reddit: 'https://www.reddit.com/r/binanceexchange',
    steemit: 'https://steemit.com/@binanceexchange',
    medium: 'https://medium.com/binanceexchange',
    instagram: 'https://www.instagram.com/Binance/',
    weibo: 'https://weibo.com/binance?is_hot=1',
    coinmarketcap: 'https://coinmarketcap.com/exchanges/binance/',
    vk: 'https://vk.com/binancerussia',
  },
  tooltip: {
    stopLimit: 'https://binance.zendesk.com/hc/%locale/articles/115003372072',
    ocoUrl: 'https://binance.zendesk.com/hc/%locale/articles/360032822231',
  },
};

export default urls;
